import { styled } from "@mui/material";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const cardFooterStyles = {
  display: "flex",
  flexDirection: "column",
  zIndex: 2
};
const StyledLabel = styled("label")({
  display: "inline-block",
  paddingLeft: SpaceXxs,
  verticalAlign: "middle"
});
export {
  StyledLabel,
  cardFooterStyles
};
